import layout from "@/layout/Layout";
import layoutBlank from "@/layout/LayoutBlank";

//人员入职
// import onboardinglist from '@/pcpage/hr/onboarding/onboarding/onboardinglist'
// import onboardingemailload from '@/pcpage/hr/onboarding/onboarding/onboardingemailload'
import onboardingload from "@/pcpage/hr/onboarding/onboarding/onboardingload";
//报错页面
// import onboardingerror from '@/pcpage/hr/onboarding/onboarding/onboardingerror'
//外网填写招聘简历信息
import positioninfolist from "@/pcpage/hr/recruitment/resumeApply/positioninfolist";
import resumeload from "@/pcpage/hr/recruitment/resumeApply/resumeload";
//招聘门户
import portal from "@/pcpage/hr/recruitment/portal/portal";
import portList from "@/pcpage/hr/recruitment/portal/portList";
import portLoad from "@/pcpage/hr/recruitment/portal/portLoad";
import information from "@/pcpage/hr/recruitment/portal/information";
import applicationList from "@/pcpage/hr/recruitment/portal/applicationList";
import applicationLoad from "@/pcpage/hr/recruitment/portal/applicationLoad";
import login from "@/pcpage/hr/recruitment/portal/login";
import signUp from "@/pcpage/hr/recruitment/portal/signUp";
import hrIndex from "@/pcpage/hr/recruitment/portal/hrIndex";
import retrievePWD from "@/pcpage/hr/recruitment/portal/retrievePWD";
import submitResume from "@/pcpage/hr/recruitment/portal/submitResume";
import successOperate from "@/pcpage/hr/recruitment/portal/successOperate";
import tempELement from "@/pcpage/hr/recruitment/portal/tempElement";

import offerprocess from "@/pcpage/hr/recruitment/portal/offerprocess";
import offerprocesstaxtable from "@/pcpage/hr/recruitment/portal/offerprocesstaxtable";

let router = [
  {
    path: "/hrIndex",
    name: "hrIndex",
    component: hrIndex
  },
  {
    path: "/hr",
    redirect: "/portal/portList",
    component: portal,
    meta: { title: "DITO Portal" }
  },
  {
    //招聘门户
    path: "/portal",
    redirect: "/portal/portList",
    component: portal,
    meta: { title: "DITO Portal" },
    children: [
      {
        path: "/portal/portList",
        component: portList,
        meta: { title: "Career at DITO" }
      },
      {
        path: "/portal/portLoad",
        component: portLoad
      },
      {
        path: "/portal/applicationList",
        component: applicationList
      },
      {
        path: "/portal/applicationList/applicationLoad",
        component: applicationLoad
      },
      {
        path: "/portal/information",
        component: information
      },
      {
        path: "/portal/login",
        component: login
      },
      {
        path: "/portal/signUp",
        component: signUp
      },
      {
        // 找回密码
        path: "/portal/retrievePassword",
        component: retrievePWD
      },
      {
        // 递交简历
        path: "/portal/submitResume",
        component: submitResume
      },
      {
        // 注册 找回密码成功
        path: "/portal/successOperate",
        component: successOperate
      },
      {
        // 临时使用
        path: "/portal/tempELement",
        component: tempELement
      },
      {
        path: "/portal/offerprocess",
        component: offerprocess
      },
      {
        path: "/portal/offerprocesstaxtable",
        component: offerprocesstaxtable
      },
    ]
  },
  {
    //门户招聘列表
    path: "/recruit/positioninfolist",
    component: positioninfolist,
    meta: { title: "DITO Recruitment" }
  },
  {
    //门户招聘列表详情
    path: "/recruit/resumeload",
    component: resumeload,
    meta: { title: "DITO Recruitment" }
  },
  {
    path: "/layoutBlank",
    component: layoutBlank,
    children: [
      {
        //人员入职
        path: "/onboarding/onboardingload",
        component: onboardingload,
        meta: { title: "MSS" }
      }
    ]
  },

  {
    path: "/layout",
    redirect: "/layout/home",
    component: layout,
    children: []
  }
];
export default router;



// WEBPACK FOOTER //
// ./src/router/hr_router.js